module.exports = __webpack_public_path__ + "img/appAsset-brand--getnet.1fa5d8f9.svg";